import { __awaiter } from "tslib";
import { Search } from "./types.js";
import { GraphRest } from "../rest.js";
export { Search, } from "./types.js";
GraphRest.prototype.query = function (...requests) {
    return __awaiter(this, void 0, void 0, function* () {
        return this.childConfigHook(({ options, baseUrl, runtime }) => {
            return Search(baseUrl).configure(options).setRuntime(runtime).executeQuery({ requests });
        });
    });
};
//# sourceMappingURL=index.js.map